export const LINK_PROJECTS_TO_WORK_ITEM_HELP_ARTICLE_URL =
	'https://support.atlassian.com/platform-experiences/docs/link-goals-and-projects-to-work-in-jira/';
